import React, { useEffect } from 'react';
import './Style.css';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            <section className="banner2">
                <div className="container3">
                    <div className="banner-content2">
                        <h2>Privacy and Policy</h2>
                    </div>
                </div>
            </section>

            <div className="cont">
                <h1>Terms of Service</h1>

                <h2>MISCELLANEOUS</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto veritatis possimus iste aut consequatur nisi ab dolor commodi alias, dolores laboriosam esse consequuntur, molestias a et sed temporibus dicta quas laborum? Non laudantium dicta, atque fugiat, similique nesciunt dolorum quisquam nobis facere perspiciatis mollitia aperiam provident, sed blanditiis culpa quidem ea aliquid optio assumenda soluta doloremque quo nulla veritatis! Nihil totam tempora cum ipsam sapiente nesciunt quia suscipit adipisci quod quisquam, beatae veritatis perspiciatis eligendi rerum illo. Ab ad odit, neque minus voluptatum nisi, iure hic error quam dolores inventore quasi ullam aspernatur impedit sunt quidem? Dolorum quisquam iure error!</p>


                <h2>PRIVACY POLICY</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto veritatis possimus iste aut consequatur nisi ab dolor commodi alias, dolores laboriosam esse consequuntur, molestias a et sed temporibus dicta quas laborum? Non laudantium dicta, atque fugiat, similique nesciunt dolorum quisquam nobis facere perspiciatis mollitia aperiam provident, sed blanditiis culpa quidem ea aliquid optio assumenda soluta doloremque quo nulla veritatis! Nihil totam tempora cum ipsam sapiente nesciunt quia suscipit adipisci quod quisquam, beatae veritatis perspiciatis eligendi rerum illo. Ab ad odit, neque minus voluptatum nisi, iure hic error quam dolores inventore quasi ullam aspernatur impedit sunt quidem? Dolorum quisquam iure error!</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
